export default __webpack_public_path__ + "static/media/invoice_list.fcb0b5f6.png";